import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonusImages, bonusTools } from '../data/bonus';
export function BonusPack() {
  return <section className="cube-grid border-t border-white/10 bg-navy-600" data-id="element-15" data-mp="1feqnys5eiuyx">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 sm:px-6 sm:py-20" data-id="element-16" data-mp="1t5m1wiurc29d">
        <div className="max-w-2xl" data-id="element-17" data-mp="1odc6inavi9zp">
          <p className="font-pixel text-[10px] uppercase tracking-[0.16em] text-brand-gold" data-id="element-18" data-mp="1ocatwee7lffv">
            Bonus Pack
          </p>
          <h2 className="mt-3 text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-19" data-mp="234l1lbxjonk8">
            Progress Feels Better When Learners Can See It.
          </h2>
          <p className="mt-3 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-20" data-mp="2c2n82701s8ew">
            The included Bonus Pack adds practical tools that help make effort
            visible and keep routines moving.
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-start lg:gap-10" data-id="element-21" data-mp="do3glpus6bbk">
          <div className="grid gap-4 sm:grid-cols-2" data-id="element-22" data-mp="1g5lnajw5kgqp">
            <figure className="border border-white/10 bg-navy-800 p-3" data-id="element-23" data-mp="1g6wrgktifqic">
              <img src={bonusImages.questMap} alt="Printable Quest Map progress sheet from the Bonus Pack" className="block w-full" data-id="element-24" data-mp="1l5ge6nfxh6br" />
              <figcaption className="pt-3 font-pixel text-[10px] uppercase tracking-[0.1em] text-white" data-id="element-25" data-mp="1uuhqo3n9l5kz">
                Quest Map
              </figcaption>
            </figure>
            <figure className="border border-white/10 bg-navy-800 p-3" data-id="element-26" data-mp="23ump3oahctn0">
              <img src={bonusImages.rewardCards} alt="Printable cut-and-collect Reward Cards sheet from the Bonus Pack" className="block w-full" data-id="element-27" data-mp="23wr2cwu9r4zy" />
              <figcaption className="pt-3 font-pixel text-[10px] uppercase tracking-[0.1em] text-white" data-id="element-28" data-mp="efycblxz99og">
                Reward Cards
              </figcaption>
            </figure>
          </div>

          <div className="border border-white/10 bg-navy-900 p-5 sm:p-6" data-id="element-29" data-mp="jgw2akp8b80i">
            <h3 className="font-pixel text-[11px] uppercase tracking-[0.1em] text-brand-emerald" data-id="element-30" data-mp="ben46r6q8h60">
              Included printable extras
            </h3>
            <ul className="mt-4 grid gap-x-6 gap-y-3 sm:grid-cols-2 lg:grid-cols-1" data-id="element-31" data-mp="lct6h9wg3pbe">
              {bonusTools.map(tool => <li key={tool} className="flex items-start gap-2.5 text-sm text-slate-200" data-id="element-32" data-mp="gbvds3dt7cvn">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" strokeWidth={3} aria-hidden="true" data-id="element-33" data-mp="qbmc6g5hqc10" />
                  {tool}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-sm font-medium text-brand-cyan sm:text-base" data-id="element-34" data-mp="1e0ysdzz8jkct">
          Simple tools that help turn completed pages into visible progress.
        </p>
      </div>
    </section>;
}